import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, LogicalService } from '@app/shared';
import {OnDestroyMixin, untilComponentDestroyed} from "@w11k/ngx-componentdestroyed";
import { Subject } from 'rxjs';
import { BreadCrumbs } from './bread-crumbs';

@Component({
  selector: 'app-bread-crumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrls: ['./bread-crumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadCrumbsComponent extends OnDestroyMixin implements OnInit, OnDestroy {
  breads: BreadCrumbs[] = [];
  destroyer$ = new Subject();

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private auth: AuthService,
    private logical: LogicalService
  ) {
    super();
  }

  ngOnInit() {
    this.createBread(this.router.url);
    this.router.events.pipe(untilComponentDestroyed(this)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.logical.scrollUP();
        this.createBread(event.urlAfterRedirects);
        // console.log(this.router.routerState.snapshot.root);
      }
    });
  }

  ngOnDestroy() {
    this.destroyer$.unsubscribe();
    this.cdr.detach();
  }

  createBread(url: string) {
    const spl = url.split('/').slice(0, 4);
    const dat = url.split('/').slice(0, 4);
    const coll = [];
    //debugger;
    
    spl.forEach(elm => {
      const len = dat.length - 1;
      let name = this.splitName(dat[len]);
      const link = name === 'home' ? this.auth?.defaultUrl : dat.join('/');
      // console.log(`${name}`);
      // console.log(`${link}`);

      if((name.toLocaleLowerCase() == 'lsq')||(name.toLocaleLowerCase() === 'rfq') || name.toLowerCase() === 'hrfq'.toLowerCase()) {
        name = name.toLocaleUpperCase();
      }
     
      if(name.toLowerCase() === 'lsq Acceptance'.toLowerCase()){
        name = 'LSQ Acceptance';
      }
       
      
      coll.push(<BreadCrumbs>{
        name: `${name}`,
        link: `${link}`
      });
      dat.splice(len, 1);
      // console.log(coll);
    });
    this.breads = coll.reverse();
    this.cdr.detectChanges();
  }

  splitName(str: string) {
    const splitString = str
      .replace(/([A-Z]+)/g, ' $1')
      .replace(/([A-Z][a-z])/g, '$1');
    return splitString || 'home';
  }
}
